import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  NavbarText,
  Nav,
  NavItem
} from 'reactstrap';
import logo from './Autodesk.jpg';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar expand="md" color="light" light className="px-3 shadow-sm">
      {/* Brand */}
      <NavbarBrand href="/" className="d-flex align-items-center gap-2 fw-bolder">
        Wocons
        <img
          src={logo}
          alt="Logo"
          width="50"
          height="50"
          style={{ objectFit: "contain", borderRadius: "6px" }}
        />
      </NavbarBrand>

      {/* Mobile Toggle Button */}
      <NavbarToggler onClick={toggle} />

      {/* Collapsible Section */}
      <Collapse isOpen={isOpen} navbar>
        <Nav className="me-auto" navbar>
          <NavItem>
            <NavbarText className="fw-semibold" disable>
              Inventor Web Configurator Demo
            </NavbarText>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default Header;
